import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import LocalFileWriterForm from '../forms/local-file-writer-form';
import { localFileWriterValidationSchema } from '../schema/localFileWriter.js';

export default function LocalFileWriterNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Local File Writer Node Details',
        altText: 'Local File Writer Node',
        defaultLabel: 'Local File Writer Node',
      }}
    >
      <CommonNode
        FormComponent={LocalFileWriterForm}
        schemaResolver={localFileWriterValidationSchema}
      />
    </NodeProvider>
  );
}
